<template>
  <div class="custom-v-dialog">
    <v-dialog v-model="dialog" width="50vw" persistent>
      <template>
        <div class="custom-empty-modal-wrapper">
          <div class="m-header">
            <div class="title-header">
              <span>{{ $t('components.email.inputs.signature.title') }}</span>
            </div>
          </div>

          <div class="m-center-part">
            <div>
              <div>{{ $t('components.email.inputs.signature.current') }}</div>
              <ckeditor
                v-if="loaded_ck"
                :editor="editor"
                v-model="editeBody"
                :config="editorConfig"
              ></ckeditor>
            </div>
          </div>
          <div class="email-response-activities">
            <div class="right-button-wrapp m-btn-wrapp">
                <div class="m-cancel-btn m-single-btn" @click="dialog = false">
                  <svg
                    id="Layer_2"
                    data-name="Layer 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 42 42"
                  >
                    <g id="Layer_1-2" data-name="Layer 1">
                      <g>
                        <g>
                          <path
                            class="cls-2"
                            d="M30.81,31.46c-.32,0-.64-.12-.88-.37L10.68,11.85c-.49-.49-.49-1.28,0-1.77.49-.49,1.28-.49,1.77,0l19.25,19.25c.49.49.49,1.28,0,1.77-.24.24-.56.37-.88.37Z"
                          />
                          <path
                            class="cls-2"
                            d="M11.56,31.46c-.32,0-.64-.12-.88-.37-.49-.49-.49-1.28,0-1.77L29.92,10.08c.49-.49,1.28-.49,1.77,0,.49.49.49,1.28,0,1.77L12.44,31.1c-.24.24-.56.37-.88.37Z"
                          />
                        </g>
                        <rect class="cls-1" x="0" width="42" height="42" />
                      </g>
                    </g>
                  </svg>
                  {{ $t('components.email.inputs.signature.cancel') }}
                </div>
                <!--dodaj ikonicu-->
                <div class="m-save-btn m-single-btn" @click="saveEmailDraft()">
                  <svg
                    id="Layer_2"
                    data-name="Layer 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 42 42"
                  >
                    <g id="Layer_1-2" data-name="Layer 1">
                      <g>
                        <g>
                          <path
                            class="cls-2"
                            d="M31.52,35.2H11.49c-2.53,0-4.6-2.06-4.6-4.6V10.58c0-2.53,2.06-4.6,4.6-4.6h16.7c.71,0,1.33.29,1.7.81.46.63,1.16,1.51,1.97,2.53,1.07,1.34,2.39,3.01,3.7,4.77.37.5.56,1.02.56,1.55v14.97c0,2.53-2.06,4.6-4.6,4.6ZM11.49,8.48c-1.16,0-2.1.94-2.1,2.1v20.03c0,1.16.94,2.1,2.1,2.1h20.02c1.16,0,2.1-.94,2.1-2.1v-14.95s-.02-.03-.06-.09c-1.28-1.72-2.59-3.37-3.64-4.7-.74-.93-1.39-1.75-1.87-2.39H11.49Z"
                          />
                          <path
                            class="cls-2"
                            d="M25.4,13.23h-7.98c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25h7.98c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25Z"
                          />
                          <path
                            class="cls-2"
                            d="M28.33,30.65h-13.44c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25h13.44c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25Z"
                          />
                        </g>
                        <rect class="cls-1" x="0" width="42" height="42" />
                      </g>
                    </g>
                  </svg>
                  {{ $t('components.email.inputs.signature.save') }}
                </div>
            </div>
          </div>
        </div>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@/plugins/ckeditor_build";

export default {
  components: {
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      editor: ClassicEditor,
      editeBody : "<p></p>",
      editorData: "<p></p>",
      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "italic",
            "fontSize", // 👈 Add this
            "link",
            "|",
            "undo",
            "redo",
            "|",
            "bulletedList",
            "numberedList",
            "texttransform",
            "",
          ],
        },
        link: {
          // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
          addTargetToExternalLinks: true,
        },
      },
      loaded_ck: false,
      dialog : false
    };
  },
  methods:{
    async open() {
      this.dialog = true;
      setTimeout(() => {
        this.loaded_ck = true;
      }, 100);
    },
  }
};

</script>

<style></style>
